var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarterIsEnabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 0.55,
    width: 24.9,
    height: 24.9,
    rx: 12.45,
    fill: "#F3FBF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 0.55,
    width: 24.9,
    height: 24.9,
    rx: 12.45,
    stroke: "#DEF3ED",
    strokeWidth: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6905 14.8477C12.552 14.8477 12.4167 14.8887 12.3015 14.9656C12.1864 15.0425 12.0967 15.1519 12.0437 15.2798C11.9907 15.4077 11.9769 15.5484 12.0039 15.6842C12.0309 15.82 12.0976 15.9447 12.1955 16.0426C12.2934 16.1405 12.4181 16.2072 12.5539 16.2342C12.6897 16.2612 12.8304 16.2474 12.9584 16.1944C13.0863 16.1414 13.1956 16.0517 13.2725 15.9366C13.3495 15.8214 13.3905 15.6861 13.3905 15.5477C13.3905 15.4557 13.3724 15.3647 13.3372 15.2798C13.302 15.1949 13.2505 15.1177 13.1855 15.0527C13.1205 14.9877 13.0433 14.9361 12.9584 14.9009C12.8734 14.8658 12.7824 14.8477 12.6905 14.8477Z",
    fill: "#1AAD7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3548 14C10.9396 14.3665 10.6777 14.9027 10.6777 15.5C10.6777 16.0973 10.9396 16.6335 11.3548 17M14.0006 14C14.4159 14.3665 14.6777 14.9027 14.6777 15.5C14.6777 16.1099 14.4047 16.656 13.9743 17.0229",
    stroke: "#1AAD7F",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3705 13C9.64383 13.6062 9.18555 14.493 9.18555 15.4811C9.18555 16.4691 9.64383 17.356 10.3705 17.9621M15.0006 13C15.7273 13.6062 16.1855 14.493 16.1855 15.4811C16.1855 16.4899 15.7078 17.3932 14.9545 18",
    stroke: "#1AAD7F",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.9502H18.5C18.8038 10.9502 19.0498 11.1962 19.0498 11.5V19.5C19.0498 19.8038 18.8038 20.0498 18.5 20.0498H7C6.69624 20.0498 6.4502 19.8038 6.4502 19.5V11.5C6.4502 11.1962 6.69624 10.9502 7 10.9502Z",
    stroke: "#1AAD7F",
    strokeWidth: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5V8.87589C9 6.7353 10.7353 5 12.8759 5V5C14.4608 5 15.886 5.96491 16.4746 7.43642L16.5 7.5",
    stroke: "#1AAD7F",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarterIsEnabled);
export default __webpack_public_path__ + "static/media/starter_is_enabled.3999f23a7ee52b24db407e8979a3917b.svg";
export { ForwardRef as ReactComponent };